import React, { useContext, useEffect, useState } from "react";
import { CloseOutlined, CheckCircleOutlined } from "@ant-design/icons";
import { Modal, Row, Col, Radio } from "antd";
import { Button } from "antd/es/radio";
import { DashboardContext } from "../../../store/context/DashboardContext";
import { formatCurrencyWithCode } from "../../../utils/helper/format";
import { useTenant } from "../../../store/context/tenant-context";

const SelectAccoutModal = ({ isModalVisible, handleOk, handleCancel }) => {
  const [selectedAccount, setSelectedAccount] = useState(null);
  const tenant = useTenant();
  const { depositPolicies } = useContext(DashboardContext);

  useEffect(() => {
    // If there's only one account, select it automatically
    if (depositPolicies.length === 1) {
      setSelectedAccount(depositPolicies[0].accountNumber);
    }
  }, [depositPolicies]);

  // useEffect(() => {
  //   if (!isModalVisible) {
  //     // If there's only one account, keep it selected
  //     if (depositPolicies.length === 1) {
  //       setSelectedAccount(depositPolicies[0].accountNumber);
  //     } else {
  //       setSelectedAccount(null);
  //     }
  //   }
  // }, [isModalVisible, depositPolicies]);

  useEffect(() => {
    if (!selectedAccount && depositPolicies.length) {
      setSelectedAccount(depositPolicies[0].accountNumber);
    }
  }, [selectedAccount, depositPolicies]);

  return (
    <Modal
      open={isModalVisible}
      onOk={handleOk}
      onCancel={handleCancel}
      footer={
        <Button
          type="primary"
          onClick={() => handleOk(selectedAccount)}
          style={{ backgroundColor: tenant.theme.colorPrimary, color: "#fff" }}
          className="h-full px-5 py-1 text-center shadow-none"
        >
          Apply
        </Button>
      }
      width={700}
      centered
      title={<h3 className="text-center">Select Account</h3>}
    >
      <h3 className="mb-4">Please select an account</h3>

      <Row gutter={[16, 16]} justify="space-between">
        {depositPolicies.map((account) => (
          <Col xs={24} md={12} key={account.accountNumber}>
            <div
              onClick={() => setSelectedAccount(account.accountNumber)}
              style={{
                border:
                  selectedAccount === account.accountNumber
                    ? `2px solid ${tenant.theme.colorPrimary}`
                    : "1px solid #ddd",
                padding: "10px",
                margin: "0px",
                borderRadius: "12px",
                backgroundColor: "#f5f5f5",
                cursor: "pointer",
                height: "100%",
                textAlign: "left",
                transition: "border 0.5s easeIn",
              }}
            >
              <div style={{ display: "flex" }}>
                {selectedAccount === account.accountNumber ? (
                  <CheckCircleOutlined
                    style={{
                      fontSize: "24px",
                      color: tenant.theme.colorPrimary,
                      marginRight: "12px",
                      position: "relative",
                      display: "inline-block",
                    }}
                  />
                ) : (
                  <span
                    style={{
                      width: "24px",
                      height: "24px",
                      position: "relative",
                      borderRadius: "50%",
                      border: `2px solid ${tenant.theme.colorPrimary}`,
                      marginRight: "12px",
                    }}
                  />
                )}

                <div>
                  <strong>{account.accountType}</strong>
                  <p style={{ margin: "10px 0" }}>
                    Account balance:{" "}
                    {formatCurrencyWithCode(account.accountBalance)}
                  </p>
                  <p>
                    {account.accountNumber} • {account.accountType}
                  </p>
                </div>
              </div>
            </div>
          </Col>
        ))}
      </Row>
    </Modal>
  );
};

export default SelectAccoutModal;
